<template>
<div>
    <h1 class="text-2xl mt-0 mb-8">Blog</h1>

    <div class="flex wrap gap-5">
        <router-link :to="`/blog/${post.slug}`"  v-for="post in posts" :key="post.slug">
            <el-card shadow="never" style="width: 400px">
                <div class="text-2xl mb-4">
                    {{post.title}}
                </div>
                <!-- <div class="text-2xl mb-4">
                    <img style="max-width: 100%" :src="post.thumbnail">
                </div> -->
                <div> 
                    {{post.summary}}
                </div>
            </el-card>
        </router-link>

    </div>
</div>
</template>

<script setup>
let posts = ref([
    {
        title: 'How to download onlyfans videos with free chrome extension',
        summary: 'In this article, we will explain how to download videos from onlyfans using a free chrome extension',
        slug: 'download-onlyfans-videos',
    },
    {
        title: 'YT Saver onlyfans downloader alternative - Free chrome extension',
        summary: 'Looking for a best YTSaver alternative? We have a free chrome extension with amazing features',
        slug: 'ytsaver-alternative',
    }
])

</script>